import _ from "lodash";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import InputBox from "./InputBox";
import { PField } from "./NestedField";
import { fieldHasError, requiredValidator } from "./validator";

export default function SelectInput({
    name,
    label,
    options,
    initialValue,
    required,
    helperText,
    sx,
    children,
    ...props
}) {
    if (options) {
        children = [];

        for (const item of options) {
            children.push(
                <MenuItem key={item} value={item}>
                    {item}
                </MenuItem>
            );
        }
    }

    const labelId = _.uniqueId(name);

    return (
        <InputBox sx={sx}>
            <PField name={name} initialValue={initialValue} validate={required ? requiredValidator : null}>
                {(fieldProps) => {
                    const hasError = fieldHasError(fieldProps.meta);

                    return (
                        <FormControl required={required} error={hasError} variant="standard" sx={{ flex: 1 }}>
                            <InputLabel id={labelId}>{label}</InputLabel>
                            <Select label={label} labelId={labelId} {...fieldProps.input} {...props}>
                                {children}
                            </Select>
                            <FormHelperText>{hasError ? fieldProps.meta.error : helperText}</FormHelperText>
                        </FormControl>
                    );
                }}
            </PField>
        </InputBox>
    );
}
